export const SALES_PHONE_NUMBER = '01 88 32 12 69'
export const SALES_PHONE_NUMBER_WITH_COUNTRY_CODE = `+33${SALES_PHONE_NUMBER.replaceAll(/\D/g, '').slice(1)}`
export const SALES_PHONE_NUMBER_DISPLAY = `+33 ${SALES_PHONE_NUMBER.slice(1)}`
export const SUPPORT_EMAIL_ADDRESS = 'support@closd.com'

// Single marketing page for every locale: no localized variant exists.
export const DATAROOM_LANDING_PAGE_URL = 'https://www.lexisnexis.com/fr-fr/produits/closd-data-room'
